import Spine from 'core/display/Spine'
import { TextStyle } from 'pixi.js'
import { signal } from 'services/SignalsService'
import { TextStyleService } from 'services/TextStyleService'
import { SpineUtils } from 'utils/Spine-Utils'

export class CascadeMultiplierSpine extends Spine{
  constructor(data) {
    super(data)
    this._data = data
    this.ori = null
    this.deffolt = '1'
    this.cascadeModel = game.models.CascadeModel.get()
    this.multiplierText = new PIXI.Text('1', this.style)
    this.multiplierText.x = 3
    this.multiplierText.anchor.set(0.5)
    TextStyleService.init()

    signal.on('CURRENT-CASCADE', this.switchMultiplier.bind(this))
    signal.on('STATE:IN:AUTO', this.defaultMultiplier.bind(this))
    signal.on('STATE:IN:FREE-BET', this.defaultMultiplier.bind(this))
    signal.on('STATE:IN:SPIN', this.defaultMultiplier.bind(this))
    signal.on('BUTTON:endFreespin', () => {
      this.multiplierText.text = this.deffolt
    })
    signal.on('BUTTON:start', () => {
      this.multiplierText.text = this.deffolt
    })
    signal.on('BUTTON:startFreespin', () => {
      this.multiplierText.text = this.deffolt
    })
    signal.on('RESIZE', async ({ orientation }) => {
      this.ori = orientation

      this.scale.set(orientation === 'land' ? this._data.scaleLand : this._data.scalePort)
      this.play(`${this._data.animation}-${this.ori}`, true)
      this.multiplierText.style = new TextStyle(TextStyleService.getText(`${this._data.customStyle}_${this.ori}`))
      this.ori === 'land' && this.toggle  ? this.x = this._data.toggleLeft : this.x = this._data.toggleRight
    })

    signal.on('BUTTON:close', this.init.bind(this))
    signal.on('TOGGLE:left', (left) => {
      this.toggle = left
      left && this.ori === 'land' ? this.x = this._data.toggleLeft : this.x = this._data.toggleRight
    })
  }

  init(){
    if (game.models.BonusMultiplierModel.isFS) {
      this.multiplierText.text = this.cascadeModel.multipliers[this.cascadeModel.multipliers.length - 1]
    }
    else {
      this.multiplierText.text = this.deffolt
    }
    SpineUtils.addObj(this, this._data.slotName, this.multiplierText)
  }

  defaultMultiplier(){
    this.play(`out-${this.ori}`, false)
      .then(() => {
        if (!game.models.BonusMultiplierModel.isFS) {
          this.multiplierText.text = this.deffolt
        }
        this.play(`in-${this.ori}`, false)
          .then(() => {
            this.play(`${this._data.animation}-${this.ori}`, true)
          })
      })
  }

  switchMultiplier(currentCascade) {
    signal.dispatch(`SOUND:MULTIPLIER:${this.ori}`)
    this.play(`out-${this.ori}`, false)
      .then(() => {
        this.cascadeModel.multipliers.forEach((number, index) => {
          if(index === currentCascade){
            this.multiplierText.text = number
          }
        })
        this.play(`in-${this.ori}`, false)
          .then(() => {
            this.play(`${this._data.animation}-${this.ori}`, true)
          })
      })
  }
}
